export default class QaiChallengeResponseViewModel {
    public challengeId: number
    public response: string
    public state: string
    public isResponseToAllChallenges: boolean
    public isResponseToAllUnansweredChallenges: boolean

    constructor(challengeId: number) {
        this.challengeId = challengeId
        this.isResponseToAllUnansweredChallenges = false
        this.isResponseToAllChallenges = false
    }
}